import React, { useEffect, useMemo, useState } from 'react';
import { TableViews } from '../constants';
import ViewTableContainer from './viewTableContainer';
import EditTableContainer from './editTableContainer';
import { useSearchDisplayFields } from 'redux/hooks/searchnFilter';
import { SearchDisplayFieldStatus } from 'business/models/Models';

interface Props {
  panelState: TableViews;
  setPanelState: React.Dispatch<React.SetStateAction<TableViews>>;
  customSelectionChange?: (rowIndices: number[]) => void;
}
const TableContainer = (props: Props) => {
  const { panelState, setPanelState, customSelectionChange } = props;
  const displayFields = useSearchDisplayFields();
  const [columnStatus, setColumnStatus] = useState<{ [columnName: string]: boolean }>({});

  const columns = useMemo(
    () =>
      displayFields
        ?.filter((sf) => sf.status === SearchDisplayFieldStatus.Display)
        .map((sf) => sf.columnHeader),
    [displayFields],
  );
  //Guard Clause
  if (columns.length === 0) {
    return <></>;
  }
  useEffect(() => {
    const columnMap = {};
    let count = 0;
    columns.forEach((column) => {
      columnMap[column] = count < 3 ? true : false;
      count += 1;
    });
    setColumnStatus(columnMap);
  }, [columns]);

  return (
    <div id="searchandfilter-table-tablecontainer" className="flex flex-col">
      {panelState === TableViews.VIEW_TABLE && (
        <ViewTableContainer
          columns={columnStatus}
          customSelectionChange={customSelectionChange}
        />
      )}
      {panelState === TableViews.EDIT_TABLE && (
        <EditTableContainer
          id='snf-tablecontainer-edittable'
          columns={columnStatus}
          setColumnStatus={setColumnStatus}
          setPanelState={setPanelState}
        />
      )}
    </div>
  );
};

export default TableContainer;
